import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { z } from "zod";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import {
  SeverityEnumSchema,
  TrendEnumSchema,
  ImpactEnumSchema,
  ProbabilityEnumSchema,
  StatusEnumSchema,
} from "@backend/src/schemas/enums";
import { createRiskSchema } from "backend/src/schemas/riskSchema";
import { UserType } from "../query/useCurrentUserQuery";

export interface RiskType {
  riskId: string;
  riskNameId: string;
  type: string;
  title: string;
  description?: string;
  impact: keyof typeof ImpactEnumSchema;
  probability: keyof typeof ProbabilityEnumSchema;
  consequences?: string;
  severity: keyof typeof SeverityEnumSchema;
  trend: keyof typeof TrendEnumSchema;
  preventiveMeasure?: string;
  correctiveMeasure?: string;
  projectId: string;
  responsibleUserId?: string | null;
  responsibleUser?:UserType |null
  status:keyof typeof StatusEnumSchema
}

type OrgAddRiskResponseType = ResponseType<RiskType>;

function useAddRiskMemberMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<OrgAddRiskResponseType>["response"],
    AxiosResponseAndError<OrgAddRiskResponseType>["error"],
    z.infer<typeof createRiskSchema>
  >({
    mutationFn: async (data) => {
      return ApiRequest.post<OrgAddRiskResponseType>(
        `${requestURLs.risk}`,
        data
      );
    },
  });

  return mutation;
}

export default useAddRiskMemberMutation;
